<template>
  <div class="framework-ratings-legend">
    <div class="title">Key:</div>
    <div class="legend-items">
      <div class="legend-item"
        v-for="n in 4"
        :key="5 - n">
        <VizFourBarRating class="small"
          :rating="5 - n"
          :xPadding="1"
        />
        <div class="name">{{ descriptionForRating(5 - n) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import VizFourBarRating, { descriptionForRating } from '@/components/VizFourBarRating'

@Component({
  methods: {
    descriptionForRating
  },
  components: {
    VizFourBarRating
  }
})
export default class FrameworkRatingsLegend extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.framework-ratings-legend {
  font-size: 12px;
  color: #555555;
  .title {
    font-weight: bold;
  }
  .legend-item {
    .viz-four-bar-rating {
      margin: 2px 2px 2px 0px;
    }
    .name {
      display: inline-block;
      vertical-align: top;
      width: 64px;
      margin-top: 3px;
    }
  }
}

/* Size/colors for rating viz (positioning is above) */
.viz-four-bar-rating {
  border-color: #999999;
  /deep/ .bar        { fill: #E3E3E3; }
  /deep/ .bar.filled { fill: #999999; }
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2017/FrameworkRatingsLegend.vue